import React from 'react';
import RenderConfiguration from './SVG';
import Card from '../../Controls/Card';
import Helper from './Helper';
export default class Render extends React.Component {
  state = {
    appear: false,
    expand: true
  };
  componentDidUpdate(prevProps) {
    if (prevProps.step < 3 && this.props.step >= 3) {
      this.setState({ appear: true });
    }
    if (prevProps.step >= 3 && this.props.step < 3 && !this.props.scrolling) {
      // this.setState({ appear: false });
    }
  }

  render() {
    const { appear, expand } = this.state;

    const {
      configuration,
      rack,
      uxPath,
      bikeConfiguration,
      marginAdds,
      width,
      length,
      handleScrollIn,
      handleScrollOut,
      parameters,
      handleStepSet,
      disableWaypoint
    } = this.props;
    return (
      <Card
        maxHeight={650}
        disableWaypoint={disableWaypoint}
        handleStepSet={handleStepSet}
        stepIndex={3}
        step={this.props.step}
        expand={expand}
        appear={appear}
        handleScrollIn={this.props.step === 3 ? handleScrollIn : () => {}}
        handleScrollOut={this.props.step === 2 ? handleScrollOut : () => {}}
        header={'Architectural Layout'}
        cardComponentStyle={{
          height: 650,
          alignItems: 'flex-start',
          alignContent: 'flex-start'
        }}
        content={
          <div>
            <RenderConfiguration
              parameters={parameters}
              actions={this.props.actions}
              pseudoKey={configuration + rack + uxPath}
              count={uxPath === 'bikes'}
              configuration={bikeConfiguration}
              title={'Max Density'}
              explainerText={marginAdds}
            />
            <Helper {...this.props} style={{ background: 'none' }} />
          </div>
        }
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Configuration/Render/index.js